import * as React from 'react';
import { Component } from 'react';
import { MapResultComponent } from '../Search/MapResultComponent';
import { IPlace } from '../../models/IPlace';
import { IAdvancedSearchItem } from '../../models/IAdvancedSearchItem';
import { IViewport } from '../../models/IViewport';


interface IProps {
    Place: IPlace,
    ResultItems: IAdvancedSearchItem[],
    OnViewPortChanged: (viewport: IViewport) => void,
    OnAbort: () => void
}



export class MapModalComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.OnCloseClick = this.OnCloseClick.bind(this);

        setTimeout((t) => {
            t.setState({});
        }, 1000, this);
    }

    public render() {
        return (
            <div className="map-modal-component">
                <div className="modal">
                    <div className="modal-main">
                        <div className="modal-main-header">
                            <a className="modal-close-btn" onClick={this.OnCloseClick}>Zamknij</a>
                        </div>
                        <div className="modal-main-content">
                            <div className="section">
                                <MapResultComponent
                                    Place={this.props.Place}
                                    ResultItems={this.props.ResultItems}
                                    OnViewPortChanged={this.props.OnViewPortChanged} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }//end-of-render

    private OnCloseClick(evt) {
        this.props.OnAbort();
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/MapModal.tsx